export default __webpack_public_path__ + "static/media/FM_Logo.c9ff309d.svg";